import React, {useEffect, useState, useCallback} from "react";
import {Select} from "antd";
import axios from "./axios";
import {debounce} from 'lodash';
import CircularLoader from "./CircularLoader";

export const ClassSelect = props => {
    const {onChange} = props;
    const [classSelectOptions, setClassSelectOptions] = useState([]);
    const [classId, setClassId] = useState(null);

    useEffect(() => {
        let isActive = true;
        axios.get('/web/ui/sc/classes').then(response => {
            if (isActive) {
                const options = Object.entries(response.data).map(([key, classObj]) => ({
                    value: key,
                    label: classObj.className
                }));
                setClassSelectOptions(options);
            }
        });
        return () => {isActive = false};
    }, []);

    useEffect(() => {
        onChange?.(classId);
    }, [classId]);

    return (
        <>
            <Select
                placeholder="Choose a class..."
                options={classSelectOptions}
                onChange={setClassId}
            />
        </>
    )
}

export const StudentSelect = props => {
    const {onChange} = props;
    const [studentSelectOptions, setStudentSelectOptions] = useState([]);
    const [studentId, setStudentId] = useState(null);
    const [validSearch, setValidSearch] = useState(false);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        onChange?.(studentId);
    }, [studentId]);

    const handleSearch = useCallback(
        debounce((newValue) => {
            setValidSearch(newValue.length >= 2);
            if (newValue && newValue.length >= 2) {
                setFetching(true);
                axios.get('/web/ui/sc/searchStudent', {
                    params: {name: newValue}
                })
                    .then(response => {
                        const results = response.data.map(user => ({
                            value: user.userId,
                            label: user.fullName,
                        }));
                        setStudentSelectOptions(results);
                    })
                    .catch(error => console.error(error))
                    .finally(() => {
                        setFetching(false);
                    });
            } else {
                setStudentSelectOptions([]);
            }
        }, 300),
    []);

    return (
        <Select
            showSearch={{
                filterOption: false,
                onSearch: handleSearch
            }}
            placeholder="Search Student..."
            defaultActiveFirstOption={false}
            suffixIcon={null}
            onChange={setStudentId}
            allowClear
            onClear={() => setStudentId(null)}
            notFoundContent={validSearch ? (fetching ? <CircularLoader displayInElement={true}/> : <div>No results found</div>) : null}
            options={studentSelectOptions}
        />
    )
}